import React from 'react'

function FindSchoolsCardIcon() {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M120 60.0089C120 93.1483 93.1306 120 59.9911 120C26.8517 120 0 93.1306 0 60.0089C0 26.8871 26.8694 0 60.0089 0C93.1483 0 120.018 26.8694 120.018 60.0089H120Z"
        className="fill"
        fill="#4A4A4A"
        fillRule="nonzero"
      />
      <path
        d="M71.5218 36.1506V28.8532L75.6133 28.8177L75.5247 27.2414L59.5129 13.3019L43.4834 27.2414L43.5011 28.8177L47.4864 28.8532V36.1329L59.4952 27.0997L71.5218 36.1506Z"
        fill="white"
      />
      <path
        d="M95.2204 58.3966V60.8409H88.2243V93.7863H109.567C107.867 96.3012 105.955 98.6573 103.9 100.871H16.0827C14.0282 98.6572 12.1328 96.3013 10.4148 93.7863H30.3943V61.0187H23.7165L23.7517 58.4152L59.4948 31.545L95.2204 58.3966ZM68.6521 53.4728C68.6173 53.4739 65.7457 53.5791 62.489 56.4132C61.196 57.5468 60.5045 58.7161 60.1325 59.7257L58.9812 54.465L55.528 55.2267L56.9626 61.798H55.9001C49.453 61.798 44.2099 65.4286 44.2097 73.2394C44.2097 81.0504 49.6477 90.0841 55.9001 90.0841H61.4255C67.1465 90.0841 73.1159 81.0504 73.1159 73.2394C73.1158 65.9423 68.546 62.2935 62.6657 61.8507C63.7993 61.4788 65.1099 60.8412 66.2966 59.6368C68.4752 57.4582 68.6521 53.4728 68.6521 53.4728Z"
        fill="white"
      />
    </svg>
  )
}

export default FindSchoolsCardIcon
